<!-- =========================================================================================
    File Name: StatisticsCard.vue
    Description: Statistics card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card class="overflow-hidden" >
      <div slot="no-body">
        <div class="vx-card__header">
            <div class="vx-card__title">
              <h4>{{ $t(i18n) || title }}</h4>
            </div>
            <div class="vx-card__actions">
              <div class="vx-card__action-buttons">
                <feather-icon v-if="enableZoomIn" @click="zoomIn" icon="SearchIcon" svgClasses="h-6 w-6" class="ml-4" />
                <feather-icon v-if="enableLinking" @click="linkToUrl" icon="CornerRightDownIcon" svgClasses="h-6 w-6" class="ml-4"/>
              </div>
            </div>
        </div>
        <vs-breadcrumb class="m-5">
          <li v-for="(link, index) in breadcrumb" :key="index" class="inline-flex items-center">
              <a class="text-primary h5" v-if="!link.actual" href="#" @click.prevent="breadcrumbDrillTo(link.id)">{{ link.label }}</a>
              <span v-else class="cursor-default h5">{{ link.label }}</span>
              <span v-if="!link.actual" class="breadcrumb-separator mx-2 flex items-start"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
          </li>
        </vs-breadcrumb>

        <!-- Chart -->
        <div>
          <vue-apex-charts type="donut" :height="chartHeight" :options="chartOptions" :series="chartData" @dataPointSelection="dataPointSelectionHandler"/>
        </div>
      </div>
      <div class="flex justify-between text-center mt-2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0" slot="no-body-bottom">
        <ul class="mt-3 ml-3 ">
            <li v-for="data in comparisonData" :key="data.name" class="flex mb-3">
              <feather-icon icon="CircleIcon" :style="{'color': getColor(data.name) }" :svgClasses="[`h-5 w-5 stroke-current`]"></feather-icon>
              <span class="ml-2 inline-block font-semibold">{{ data.name }}</span>
              <span class="mx-2">  a :</span>
              <span >{{ formatData(data.actual) }}</span>
              <span class="mx-2"> b :</span>
              <span class="mr-1">{{ formatData(data.budget) }}</span>
              <feather-icon :icon="data.actual - data.budget < 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'" :svgClasses="[data.actual - data.budget < 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"></feather-icon>
            </li>
        </ul>
      </div>
    </vx-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import chartConfigs from './chartConfigs.js'
import shared from '@/filters/shared.js'


export default {
  props: {
    title: {
      type: String
    },
    i18n : {
      type: String
    },
    linkTo: {
      type: String
    },
    enableZoomIn: {
      type: Boolean,
      default: false
    },
    enableDrill: {
      type: Boolean,
      default: false
    },
    size : {
      type: Number,
      default : 0
    },
    labels : {

    },
    chartData: {
      // type: Array,
      // required: true
    },
    comparisonData: {

    },    
    dataFilter: {
      type: String
    }
  },
  watch: {
    labels (newValue) { 
      this.refreshChartOption(newValue);
    } 
  },
  computed : {
    enableLinking() {
      return this.linkTo !== "" && typeof this.linkTo !== 'undefined';
    },
    chartHeight() {
      return this.size === 0 ? 160 : 234;
    }
  },
  data () {
    return {
      chartOptions: null,
      breadcrumb : [{ id : '', label : 'All', actual :  true}]
    }
  },
  components: {
    VueApexCharts
  },
  created () {
    this.refreshChartOption(this.$props.labels);
  },
  methods: {
    formatData(value) {
      return shared.formatValue(value, this.dataFilter, this);
    },
    refreshChartOption(labels) {
      const opt = Object.assign({}, chartConfigs.donutChart)
      if (labels) {
        opt.labels = Object.values(labels);
      }

      this.chartOptions = opt;

    },
    getColor(name) {
      const labels = Object.values(this.$props.labels);
      const index =  labels.indexOf(name);
      if (index !== -1 && this.chartOptions.colors) {
        return this.chartOptions.colors[index % this.chartOptions.colors.length];
      }
      else
        return '#000000';

    },
    zoomIn() {
      this.$emit("onZoomIn");
    },
    linkToUrl() {
      this.$emit("onDrillTo", this.linkTo);
    },
    breadcrumbDrillTo(accountId) {
      const linkIndex = this.breadcrumb.findIndex(item => item.id === accountId);
      this.breadcrumb.splice(linkIndex + 1);
      this.breadcrumb[linkIndex].actual = true;
      this.$emit("onChildClick", accountId);
    },
    dataPointSelectionHandler(e, chartContext, config) {
      if (this.enableDrill) {
        
        const parentLabel = config.w.config.labels[config.dataPointIndex];
        const accountId = Object.keys(this.$props.labels).find(key => this.$props.labels[key] === parentLabel);

        this.breadcrumb.forEach((part, index) => {
          this.breadcrumb[index].actual = false;
        });

        const current = {id : accountId, label : parentLabel, actual : true};
        this.breadcrumb.push(current);
        

        this.$emit("onChildClick", accountId);
      }
    }
  }
}
</script>
